module.exports = __webpack_public_path__ + "img/youtube_black.c0fb5d14.png";